import { useEffect, useState } from "react";
import { useDealer } from "~/entity/Dealer";
import { useContract } from "./useContract";
import { ContractIProps } from "../model/schema";

interface ResultIProps {
  contractDateParent?: Date | string;
  contractNumberParent?: string;
  parentContractId?: number;
}

export const useDefaultDataAdditional = (dealerId: string) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getById } = useDealer();
  const { getContractList } = useContract();

  const fetchData = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const params = new URLSearchParams();
      params.append("id", dealerId);
      const contractParams = new URLSearchParams();
      contractParams.append("dealerSearch[ids][]", dealerId);
      contractParams.append("contractType", "main");

      const [responseDealer, parentContract] = await Promise.all([
        getById(params.toString()),
        getContractList(contractParams.toString()),
      ]);

      if (responseDealer.status && responseDealer.status >= 400) {
        throw new Error(`${responseDealer.status}`);
      }
      if (parentContract.status && parentContract.status >= 400) {
        throw new Error(`${parentContract.status}`);
      }

      const { inn, code, dealerName, category, main } = responseDealer.data;

      let result: ResultIProps = {};

      if (parentContract) {
        const data = parentContract.data.dealers[0].contracts;

        if (data.length) {
          const newData = data
            .filter(
              (contract: ContractIProps) => contract.contractType === "main"
            )
            .sort((a, b) => b.id - a.id)[0];
          result.contractNumberParent = newData?.contractNumber
            ? newData.contractNumber
            : "";
          result.contractDateParent = newData?.contractDate
            ? new Date(newData.contractDate.split("T")[0])
            : "";
          result.parentContractId = newData.id;
        }
      }

      setData({
        inn,
        code,
        name: dealerName,
        category,
        isHeadCompany: main === 1 ? "Да" : "Нет",
        contractDateParent: result.contractDateParent,
        contractNumberParent: result.contractNumberParent,
        parentContractId: result.parentContractId,
      });
    } catch (e: any) {
      setError(e as Error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { data, isLoading, error };
};
